var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"m-0 text-center border-1 rounded",attrs:{"show":"","variant":"info"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.bannerMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }